module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_library.js
// module id = 147
// module chunks = 1